<script setup>
import { useRouter } from "vue-router";

const props = defineProps({
    name: {
        type: String,
        required: true,
    },
    time: {
        type: String,
        required: true,
    },
    image: {
        type: String,
        required: true,
    },
    session: {
        type: Object,
        required: true,
    },
});

const router = useRouter();

// eslint-disable-next-line no-unused-vars
function redirectToSession(session) {
    const params = {
        venueId: props.session.venue_id,
        actId: props.session.activity_id,
        termId: props.session.termdate_id,
        sessionId: props.session.timetable_id,
    };

    if (session.day !== null) {
        params.weekday = props.session.day.substring(0, 3);
    }

    router.push({
        name: "Advanced event series",
        params,
    });
}
</script>
<template>
    <div class="d-flex flex-row session-card">
        <div class="session-image">
            <img class="session-image" :src="props.image"/>
        </div>
        <div class="ml-3">
            <div class="session-time">{{ props.time }}</div>
            <div class="session-name">{{ props.name }}</div>
        </div>
        <div @click="redirectToSession(session)" class="ml-auto go-to align-self-center">
            <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19.0312 10.5C19.0312 5.78854 15.2115 1.96875 10.5 1.96875C5.78853 1.96875 1.96875 5.78854 1.96875 10.5C1.96875 15.2115 5.78854 19.0313 10.5 19.0313C15.2115 19.0313 19.0312 15.2115 19.0312 10.5ZM10.3093 14.2472C10.2481 14.1865 10.1994 14.1143 10.1661 14.0348C10.1328 13.9553 10.1155 13.8701 10.1152 13.7839C10.1148 13.6977 10.1315 13.6123 10.1641 13.5325C10.1968 13.4527 10.2449 13.3802 10.3056 13.319L12.4515 11.1563L6.97266 11.1563C6.79861 11.1563 6.63169 11.0871 6.50862 10.964C6.38555 10.841 6.31641 10.674 6.31641 10.5C6.31641 10.326 6.38555 10.159 6.50862 10.036C6.63169 9.91289 6.79861 9.84375 6.97266 9.84375L12.4515 9.84375L10.3056 7.681C10.2449 7.61975 10.1968 7.54716 10.1642 7.46735C10.1315 7.38754 10.1149 7.30208 10.1153 7.21585C10.1157 7.12962 10.1331 7.04431 10.1664 6.9648C10.1998 6.88528 10.2484 6.81311 10.3097 6.7524C10.3709 6.6917 10.4435 6.64365 10.5233 6.61101C10.6031 6.57836 10.6886 6.56175 10.7748 6.56214C10.8611 6.56252 10.9464 6.57988 11.0259 6.61323C11.1054 6.64658 11.1776 6.69526 11.2383 6.75651L14.4945 10.0378C14.6165 10.1607 14.6849 10.3268 14.6849 10.5C14.6849 10.6732 14.6165 10.8393 14.4945 10.9622L11.2383 14.2435C11.1776 14.3048 11.1054 14.3536 11.0258 14.3869C10.9462 14.4203 10.8608 14.4377 10.7745 14.438C10.6883 14.4384 10.6027 14.4217 10.5229 14.3889C10.4431 14.3562 10.3705 14.308 10.3093 14.2472Z"
                    fill="#FFB700"/>
            </svg>
        </div>
    </div>
</template>
<style scoped>
.session-card {
    background: #FFFFFF;
    border-radius: 7.5px;
    padding: 0.75rem;
    margin-bottom: 1rem;
}

.session-image {
    border-radius: 2px;
    width: 50px;
    height: 50px;
}

.session-time {
    font-style: normal;
    font-weight: 600;
    font-size: 0.875rem;
    line-height: 1.3rem;
    color: #272529;
    margin-bottom: 0.5rem;
}

.session-name {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: #636066;
}

.go-to {
    font-size: 25px;
    height: 25px;
    width: 25px;
    cursor: pointer;
}
</style>
